export default {
  paused: 'Online payments are paused due to KYC verification issues.',
  deadline_warning: 'KYC verification is required, otherwise online payments will be paused on {{date}}.',
  complete_verification: 'Complete verification',
  partner: {
    action_needed: 'Your payment provider needs one more thing before this restaurant can take online payments.',
    hosted_incomplete: 'You haven’t finished setting up online payments with your payment provider yet.',
    link_expired: 'Your link to finish setting up online payments has expired. Get a new one and continue.',
    open_error: 'The payment provider could not be reached. Try again in a few minutes.',
    hosted_not_started: 'Online payments are not set up with your payment provider yet.',
    business_details_missing: 'Add your business details to start taking online payments.',
    continue: 'Continue',
  },
};
